import * as React from 'react';

export default function BusinessSignUp() {
  return (
    <div className="tc mv4">
      <a
        href="https://business.filtru.coffee"
        className="f5 dib b lh-copy mid-orange link underline-hover"
      >
        Running a Coffee Business? Create your brand page and share brew recipes
      </a>
    </div>
  );
}
